import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../lib/auth";
import { useAcoesVisita } from "../lib/acoesVisita";
import { buscarVisitas, intervaloHoje } from "../lib/visitas";
import { Cabecalho } from "../components/Layout";
import { BotaoNovaVisita } from "../components/BotaoNovaVisita";
import { TabelaVisitas } from "../components/TabelaVisitas";
import type { Visita } from "../lib/tipos";

export default function Hoje() {
  const { podeAoMenos } = useAuth();
  const podeEditar = podeAoMenos("CONSULTOR");
  const [itens, setItens] = useState<Visita[]>([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState("");

  const carregar = useCallback(async () => {
    setCarregando(true);
    try {
      const r = await buscarVisitas({ ...intervaloHoje(), porPagina: 200 });
      setItens(r.itens);
      setErro("");
    } catch (e) {
      setErro(e instanceof Error ? e.message : "Falha ao carregar");
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);
  const acoes = useAcoesVisita(carregar);

  return (
    <>
      <Cabecalho titulo="Visitas de Hoje" />
      {podeEditar && (
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }}>
          <BotaoNovaVisita onClick={acoes.abrirNova} />
        </div>
      )}
      {erro && <div className="erro" style={{ marginBottom: 12 }}>{erro}</div>}
      <TabelaVisitas
        visitas={itens}
        carregando={carregando}
        vazio="Nenhuma visita agendada para hoje"
        colunas={["responsavel", "aluno", "telefone", "curso", "serie", "inicio", "status", "valor"]}
        podeEditar={podeEditar}
        onEditar={acoes.abrirEdicao}
        onFicha={acoes.abrirFicha}
        onExcluir={acoes.excluir}
        onWhatsapp={acoes.enviarWhatsapp}
      />
      {acoes.modais}
    </>
  );
}
